import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  const themeContext = useContext(ThemeContext);

  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.8 4.7998L18 11.9998M18 11.9998L10.8 19.1998M18 11.9998H6"
        stroke={themeContext.colors.font1}
        strokeOpacity="0.87"
        strokeWidth="1.8"
      />
    </Svg>
  );
};

export default Icon;
